import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Input,
  InputGroup,
  Label,
  Card,
  CardBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import StudentCourse from "../../components/Student/StudentCourse";
import { BounceLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import jump from "jump.js";
import { FaCaretDown, FaCheck, FaSortAmountDown } from "react-icons/fa";
import { GetStudentCourses } from "../../actions/studentQueries";
function Student() {
  const [filterSearch, setFilterSearch] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [sortedCourses, setSortedCourses] = useState([]);
  const [sortBy, setSortBy] = useState("courseOrder");
  const [sortingDropdownOpen, setSortingDropdownOpen] = useState(false);
  const studentCourses = GetStudentCourses();
  const scrollToTop = () => {
    jump("body", { duration: 600 });
  };

  useEffect(() => {
    const handleScrollButton = () => {
      setShowButton(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScrollButton);
    return () => window.removeEventListener("scroll", handleScrollButton);
  }, []);

  useEffect(() => {
    const sortByStatus = (items, priorityStatus) => {
      return [...items].sort((a, b) => {
        if (a.status === priorityStatus && b.status !== priorityStatus)
          return -1;
        if (b.status === priorityStatus && a.status !== priorityStatus)
          return 1;
        return 0;
      });
    };
    if (!studentCourses.isPending && studentCourses.data?.length > 0)
      switch (sortBy) {
        case "courseOrder": {
          setSortedCourses([...studentCourses.data]);
          break;
        }
        case "InProgress": {
          setSortedCourses([
            ...sortByStatus(studentCourses.data, "InProgress"),
          ]);
          break;
        }
        case "done": {
          setSortedCourses([
            ...sortByStatus(studentCourses.data, "done"),
          ]);
          break;
        }
        case "lastRun": {
          setSortedCourses(
            [...studentCourses.data].sort((a, b) => {
              const latestA = a.modules.reduce(
                (latest, mod) =>
                  mod.lastRun &&
                  (!latest || new Date(mod.lastRun) > new Date(latest))
                    ? mod.lastRun
                    : latest,
                null
              );

              const latestB = b.modules.reduce(
                (latest, mod) =>
                  mod.lastRun &&
                  (!latest || new Date(mod.lastRun) > new Date(latest))
                    ? mod.lastRun
                    : latest,
                null
              );

              return new Date(latestB) - new Date(latestA);
            })
          );
          break;
        }
        default: {
          setSortedCourses([...studentCourses.data]);
        }
      }
  }, [studentCourses.data, studentCourses.isPending, sortBy]);

  const showLoader = () => {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <BounceLoader color={"#fff"} loading={true} />
      </div>
    );
  };
  const toggle = () => setSortingDropdownOpen((prevState) => !prevState);

  if (studentCourses.isPending) {
    return showLoader();
  }
  let mappedInputSearch = null;
  let mappedCourses = null;

  if (studentCourses.error) {
    mappedCourses = (
      <Col
        xs="12"
        sm="12"
        md="12"
        xl="12"
        lg="12"
        className="d-flex flex-column align-items-center justify-content-center text-center"
      >
        <BounceLoader color={"#869fac"} loading={true} />
        <div className="text-primary lead">
          <FormattedMessage id="Views.Student.NoCourses" />
        </div>
      </Col>
    );
  } else {
    mappedInputSearch = (
      <Row className="fixed-header">
        <Col xs="6" md="6" className="ps-lg-5 ps-3">
          <span>
            <Dropdown isOpen={sortingDropdownOpen} toggle={toggle}>
              <DropdownToggle
                outline
                color="primary"
                style={{ fontSize: "initial" }}
              >
                <Row className="align-items-center d-flex mx-0">
                  <Col xs="auto" className="d-flex align-items-center px-0">
                    <FaSortAmountDown />
                  </Col>
                  <Col xs="auto" className="d-flex align-items-center px-0">
                    <FormattedMessage id="Sort" />
                  </Col>
                  <Col xs="auto" className="d-flex align-items-center px-0">
                    <FaCaretDown />
                  </Col>
                </Row>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => setSortBy("courseOrder")}>
                  {sortBy === "courseOrder" && <FaCheck className="me-1" />}
                  <FormattedMessage id="CourseOrder" />
                </DropdownItem>
                <DropdownItem onClick={() => setSortBy("InProgress")}>
                  {sortBy === "InProgress" && <FaCheck className="me-1" />}
                  <FormattedMessage id="OngoingFirst" />
                </DropdownItem>
                <DropdownItem onClick={() => setSortBy("done")}>
                  {sortBy === "done" && <FaCheck className="me-1" />}
                  <FormattedMessage id="DoneFirst" />
                </DropdownItem>
                <DropdownItem onClick={() => setSortBy("lastRun")}>
                  {sortBy === "lastRun" && <FaCheck className="me-1" />}
                  <FormattedMessage id="LastRun" />
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </span>
        </Col>
        <Col xs="6" md="6" className="pe-lg-5 pe-3">
          <InputGroup
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "60%",
              marginLeft: "auto",
            }}
          >
            <Label
              for="searchInput"
              className="d-none d-sm-block"
              style={{ marginBottom: "0", paddingRight: "5px" }}
            >
              <FontAwesomeIcon icon="search" size="2x" />
            </Label>

            <Input
              className="form-control"
              id="searchInput"
              placeholder="Sök kurs"
              onChange={(data) => setFilterSearch(data.target.value)}
              style={{
                borderRadius: "25px",
                padding: "10px 20px",
                fontSize: "1rem",
              }}
            />
          </InputGroup>
        </Col>
      </Row>
    );
  }

  if (sortedCourses.length) {
    var currentResult = sortedCourses;
    if (filterSearch.length > 0) {
      currentResult = currentResult.filter(
        (course) =>
          course.name.toLowerCase().indexOf(filterSearch.toLowerCase()) !== -1
      );
    }

    mappedCourses = currentResult.map((course, i) => (
      <Col
        md="4"
        xl="4"
        sm="6"
        xs="12"
        key={i}
        style={{ marginBottom: "1.875rem" }}
      >
        <StudentCourse course={course} />
      </Col>
    ));
  }

  return (
    <div className="animated studentLandingOverview">
      <div className="studentSearch">{mappedInputSearch}</div>
      <Card style={{ border: "1px solid #fff", padding: "1rem" }}>
        <CardBody className="mt-5">
          <Row xs="1" sm="2" md="3" xl="3" lg="3" className="d-flex">
            {mappedCourses}
          </Row>
        </CardBody>
      </Card>

      {showButton && (
        <Button onClick={scrollToTop} className="backToTopButton">
          <FontAwesomeIcon icon="arrow-up" size="lg" color="#fff" />
        </Button>
      )}
    </div>
  );
}

export default Student;
